import React, { useState } from "react";
import { Button } from "react-bootstrap";
import "./style.css";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";

const LockUnLock = () => {
  const [isLocked, setIsLocked] = useState(false);

  console.log(isLocked);

  return (
    <>
      <Button onClick={() => setIsLocked(!isLocked)} variant="outline">
        {isLocked ? <LockOutlinedIcon /> : <LockOpenOutlinedIcon />}
      </Button>
    </>
  );
};

export default LockUnLock;
